import React, { useState, useEffect } from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';

const Overlay = styled.div`${tw`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50`}`;
const Modal = styled.div`${tw`bg-white rounded-lg p-8 w-full max-w-lg max-h-screen overflow-y-auto`}`;
const Title = tw.h2`text-xl font-bold mb-6 text-gray-800`;
const Label = tw.label`block text-sm font-semibold text-gray-600 mb-1`;
const Input = tw.input`w-full border border-gray-300 rounded px-3 py-2 mb-4 text-sm focus:outline-none focus:border-green-500`;
const Row = tw.div`flex gap-3`;
const ButtonRow = tw.div`flex justify-end gap-3 mt-2`;
const SaveBtn = tw.button`bg-green-500 text-white px-5 py-2 rounded font-semibold hover:bg-green-600 transition`;
const CancelBtn = tw.button`bg-gray-200 text-gray-700 px-5 py-2 rounded font-semibold hover:bg-gray-300 transition`;

const EMPTY = { FirstName: '', LastName: '', Email: '', Phone: '', address: '' };

export default function AdminCustomerForm({ item, onSave, onCancel }) {
    const [form, setForm] = useState(EMPTY);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (item) {
            setForm({
                FirstName: item.FirstName || '',
                LastName: item.LastName || '',
                Email: item.Email || '',
                Phone: item.Phone || '',
                address: item.address || item.deliveryAddress || ''
            });
        } else {
            setForm(EMPTY);
        }
    }, [item]);

    const set = (field) => (e) => {
        const val = e.target.value;
        setForm(f => ({ ...f, [field]: val }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.FirstName.trim() || !form.LastName.trim()) {
            alert('First Name and Last Name are required');
            return;
        }
        if (!form.Email.trim()) {
            alert('Email is required');
            return;
        }

        setSaving(true);
        try {
            // Include both address keys for compatibility
            const data = {
                ...form,
                deliveryAddress: form.address,
                address: form.address
            };
            await onSave(data);
        } catch (err) {
            console.error('AdminCustomerForm save error:', err);
            alert('Save failed: ' + (err?.message || JSON.stringify(err)));
        } finally {
            setSaving(false);
        }
    };

    return (
        <Overlay onClick={onCancel}>
            <Modal onClick={e => e.stopPropagation()}>
                <Title>Edit Customer Profile</Title>
                <form onSubmit={handleSubmit}>
                    <Row>
                        <div style={{ flex: 1 }}>
                            <Label>First Name *</Label>
                            <Input value={form.FirstName} onChange={set('FirstName')} placeholder="John" required />
                        </div>
                        <div style={{ flex: 1 }}>
                            <Label>Last Name *</Label>
                            <Input value={form.LastName} onChange={set('LastName')} placeholder="Doe" required />
                        </div>
                    </Row>

                    <Label>Email Address *</Label>
                    <Input value={form.Email} onChange={set('Email')} type="email" placeholder="john.doe@example.com" required />

                    <Label>Phone Number</Label>
                    <Input value={form.Phone} onChange={set('Phone')} placeholder="e.g. 08012345678" />

                    <Label>Default Delivery Address</Label>
                    <Input value={form.address} onChange={set('address')} placeholder="e.g. 12, Isaac John Street, Ikeja, Lagos" />

                    <ButtonRow>
                        <CancelBtn type="button" onClick={onCancel} disabled={saving}>Cancel</CancelBtn>
                        <SaveBtn type="submit" disabled={saving}>
                            {saving ? 'Saving...' : 'Save'}
                        </SaveBtn>
                    </ButtonRow>
                </form>
            </Modal>
        </Overlay>
    );
}
